import { useState } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePicker = ({ value, onChange, testId, disablePast = false }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T12:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="input-dark h-10 w-44 rounded-md border px-3 text-sm flex items-center gap-2 text-left" data-testid={testId}>
          <CalendarIcon className="w-4 h-4 text-[#6B7280]" />
          {selected ? format(selected, "dd/MM/yyyy") : <span className="text-[#6B7280]">Vencimento</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#111827] border-[#1F2937] text-[#F9FAFB]" align="start" side="bottom" avoidCollisions={false}>
        <Calendar mode="single" locale={ptBR} selected={selected} defaultMonth={selected} disabled={disablePast ? { before: new Date() } : undefined}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} data-testid={`${testId}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};
